import InlineEditSelect from '@components/v2/form/InlineEditSelect/InlineEditSelect';
import ObjectScreen from '@components/v2/layout/ObjectScreen/ObjectScreen';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../../../utils/testIds/CatalogProducts.testIds';
import { Catalog } from '../../../../../../catalog.types';
import CatalogDetailField from '../CatalogDetailField';
import CatalogNavigationLockAlert from '../CatalogNavigationLockAlert';
import useCatalogDisplaySection from './hooks/useCatalogDisplaySection';

export type CatalogDisplaySectionProps = Pick<
  Catalog,
  | 'id'
  | 'showUnavailableProductsForSale'
  | 'withMedia'
  | 'isDynamic'
  | 'groupColorsInSingleCard'
  | 'navigationFilterRelatedProducts'
  | 'navigationColorMode'
> & {
  isReadOnly: boolean;
};

const CatalogDisplaySection = (props: CatalogDisplaySectionProps) => {
  const {
    isDynamic,
    isFieldDisabled,
    isNavigationPreferenceDisabled,
    isNavigationLocked,
    isUnavailableProductColorDisabled,
    values,
    options,
    submitColorMode,
    submitUnavailableProductColor,
    submitProductColorCards,
    submitProductWithoutMedia,
    submitRelatedProducts,
  } = useCatalogDisplaySection(props);

  return (
    <ObjectScreen.Section
      title={LangEnum.CATALOGS_CREATION_MODAL_SECTION_PRODUCT_PRESENTATION}
      isDefaultOpen
      persistKey="catalog-details:display"
      alert={isNavigationLocked ? <CatalogNavigationLockAlert /> : undefined}
    >
      <Stack sx={{ gap: 0.75 }}>
        <CatalogDetailField
          width="50%"
          maxWidth="50%"
          label={LangEnum.CATALOGS_CREATION_MODAL_DISPLAYED_COLORS}
          control={
            <InlineEditSelect
              value={values.colorMode}
              options={options.colorMode}
              isDisabled={isNavigationPreferenceDisabled}
              testId={CatalogProductsTestIds.DETAILS_DISPLAY_COLOR_MODE}
              onConfirm={submitColorMode}
            />
          }
        />
        <CatalogDetailField
          width="50%"
          maxWidth="50%"
          label={LangEnum.CATALOGS_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR}
          control={
            <InlineEditSelect
              value={values.unavailableProductColor}
              options={options.unavailableProductColor}
              isDisabled={isUnavailableProductColorDisabled}
              testId={CatalogProductsTestIds.DETAILS_DISPLAY_UNAVAILABLE_PRODUCTS}
              onConfirm={submitUnavailableProductColor}
            />
          }
        />
        <CatalogDetailField
          width="50%"
          maxWidth="50%"
          label={LangEnum.CATALOGS_CREATION_MODAL_PRODUCT_COLOR_CARDS}
          control={
            <InlineEditSelect
              value={values.productColorCards}
              options={options.productColorCards}
              isDisabled={isFieldDisabled}
              testId={CatalogProductsTestIds.DETAILS_DISPLAY_PRODUCT_COLOR_CARDS}
              onConfirm={submitProductColorCards}
            />
          }
        />
        {isDynamic && (
          <CatalogDetailField
            width="50%"
            maxWidth="50%"
            label={LangEnum.CATALOGS_CREATION_MODAL_PRODUCT_WITHOUT_MEDIA}
            control={
              <InlineEditSelect
                value={values.productWithoutMedia}
                options={options.productWithoutMedia}
                isDisabled={isFieldDisabled}
                testId={CatalogProductsTestIds.DETAILS_DISPLAY_PRODUCT_WITHOUT_MEDIA}
                onConfirm={submitProductWithoutMedia}
              />
            }
          />
        )}
        <CatalogDetailField
          width="50%"
          maxWidth="50%"
          label={LangEnum.GLOBAL_RELATED_PRODUCTS}
          control={
            <InlineEditSelect
              value={values.relatedProducts}
              options={options.relatedProducts}
              isDisabled={isNavigationPreferenceDisabled}
              testId={CatalogProductsTestIds.DETAILS_DISPLAY_RELATED_PRODUCTS}
              onConfirm={submitRelatedProducts}
            />
          }
        />
      </Stack>
    </ObjectScreen.Section>
  );
};

export default CatalogDisplaySection;
